shadow$provide[480] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Program:{enumerable:true, get:function() {
  return Program;
}}});
var require$_DOT__SLASH_snippet = require("./snippet");
var require$_DOT__SLASH_assemble = require("./assemble");
class Program {
  static initClass() {
    this.index = 0;
  }
  static entry() {
    return `_pg_${++Program.index}_`;
  }
  constructor(language, namespace, graph) {
    this.language = language;
    this.namespace = namespace;
    this.graph = graph;
    this.calls = {};
    this.requires = {};
  }
  call(node, module, priority) {
    let exists;
    const ns = module.namespace;
    if (exists = this.calls[ns]) {
      exists.priority = Math.max(exists.priority, priority);
    } else {
      this.calls[ns] = {node, module, priority};
    }
    return this;
  }
  require(node, module) {
    const ns = module.namespace;
    return this.requires[ns] = {node, module};
  }
  assemble() {
    const data = (0,require$_DOT__SLASH_assemble.assemble)(this.language, this.namespace != null ? this.namespace : Program.entry, this.calls, this.requires);
    const snippet = new require$_DOT__SLASH_snippet.Snippet();
    for (const key in data) {
      snippet[key] = data[key];
    }
    snippet.graph = this.graph;
    return snippet;
  }
}
Program.initClass();

};